import { createContext, useContext } from 'react';

import { ApiError } from '../api';
import { LoadingStatus, Tenant } from '../types';

export interface TenantContextShape {
    tenant: Tenant | null;
    error?: ApiError;
    status: LoadingStatus;
}

export const initialValue: TenantContextShape = {
    tenant: null,
    status: 'idle'
};

export const TenantContext = createContext<TenantContextShape>(initialValue);

export const TenantProvider = TenantContext.Provider;

/**
 * Note: tenant is checked for null before rendering application content,
 * so it's safe to case it to Tenant type.
 */
export function useTenantContext(): Tenant {
    const { tenant } = useContext(TenantContext);

    return tenant as Tenant;
}
